import {
  AudioIcon,
  BookOpenIcon,
  CheckThinIcon,
  CloseIcon,
  ContainerIcon,
  FaceWinkIcon,
  FileIcon,
  FolderIcon,
  GlobeIcon,
  SettingsIcon,
  StarsIcon,
  SubtitlesDisabledIcon,
  TranslateIcon,
  UserCheckIcon,
  UserManagerIcon,
  UsersIcon,
  VoiceIcon,
  WandIcon,
} from '@braskai/icons';

const BULLETS = {
  aiRewrite: {
    description: 'AI script adjustment',
    icon: <StarsIcon />,
  },
  api: {
    description: 'API access',
    icon: <ContainerIcon />,
  },
  audioDownload: {
    description: 'Download generated voice with background sound',
    icon: <AudioIcon />,
  },
  businessContract: {
    description: 'Business contract and invoicing',
    icon: <FileIcon />,
  },
  customPriceForMins: {
    description: 'Custom price for minutes',
    icon: <CheckThinIcon />,
  },
  downloadGeneratedVoice: {
    description: 'Download generated voice',
    icon: <VoiceIcon />,
  },
  glossary: {
    description: 'Translation dictionaries',
    icon: <BookOpenIcon />,
  },
  humanInTheLoop: {
    description: 'Human-in-the-loop',
    icon: <UserCheckIcon />,
  },
  lipSync: {
    description: 'Multispeaker Lip-Sync',
    icon: <FaceWinkIcon />,
  },
  noWatermark: {
    description: 'No watermark',
    icon: <CloseIcon />,
  },
  personalManager: {
    description: 'Personal Customer Manager',
    icon: <UserManagerIcon />,
  },
  simultaneousMultiLanguageTranslation: {
    description: 'Simultaneous multi-language translation',
    icon: <GlobeIcon />,
  },
  srtUploadDownload: {
    description: 'SRT transcript upload and SRT download',
    icon: <FileIcon />,
  },
  subtitles: {
    description: 'Automated captions/subtitles',
    icon: <SubtitlesDisabledIcon />,
  },
  teamspace: {
    description: 'Unlimited Teamspaces and members',
    icon: <UsersIcon />,
  },
  teamspaceBusiness: {
    description: '1 Team space with up to 5 members',
    icon: <UsersIcon />,
  },
  teamspaceCreatorPro: {
    description: '1 Team space with up to 10 members',
    icon: <UsersIcon />,
  },
  translate100: {
    description: 'From 100 minutes every month',
    icon: <TranslateIcon />,
  },
  translate2000: {
    description: 'From 2000 minutes every month',
    icon: <TranslateIcon />,
  },
  translate25: {
    description: 'From 25 minutes every month',
    icon: <TranslateIcon />,
  },
  translate500: {
    description: 'From 500 minutes every month',
    icon: <TranslateIcon />,
  },
  userPrompting: {
    description: 'Translation prompting',
    icon: <WandIcon />,
  },
  voiceCloneSettings: {
    description: 'Voice Clone settings',
    icon: <SettingsIcon />,
  },
  voicePresets: {
    description: 'Custom Voice Clone library',
    icon: <FolderIcon />,
  },
  voicePresets10: {
    description: 'Custom Voice Clone library (10 custom voices)',
    icon: <FolderIcon />,
  },
  voicePresetsUnlimited: {
    description: 'Up to unlimited Custom Voice Clones',
    icon: <FolderIcon />,
  },
} as const;

export const getBullets = (keys: (keyof typeof BULLETS)[]) =>
  keys.filter((key) => key in BULLETS).map((key) => BULLETS[key]);
